import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { motion } from 'framer-motion';
import { usePrefersReducedMotion } from './usePrefersReducedMotion';
export function AnimatedHeading({ text, className, as: Tag = 'h2', delay = 0, wordStagger = 0.06, }) {
    const reduced = usePrefersReducedMotion();
    const words = text.split(' ');
    if (reduced) {
        return _jsx(Tag, { className: className, children: text });
    }
    /*
     * Use `animate` (mount-time) instead of `whileInView` so above-the-fold
     * headings never get stuck at opacity:0.
     *
     * Each word is a `motion.span` with an EXPLICIT text-node space between
     * adjacent spans. Previously `marginRight: 0.25em` was the only spacer
     * which is too tight for script fonts (Allura) - adjacent inline-block
     * spans without a text node have NO whitespace, so "Mon panier" rendered
     * as "Monpanier". A real space character preserves natural word-spacing
     * regardless of font.
     */
    return (_jsx(Tag, { className: className, children: words.map((word, i) => (_jsxs(Fragment, { children: [_jsx(motion.span, { style: { display: 'inline-block' }, initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: {
                        duration: 0.7,
                        ease: [0.22, 1, 0.36, 1],
                        delay: delay + i * wordStagger,
                    }, children: word }), i < words.length - 1 && ' '] }, `${word}-${i}`))) }));
}
